<template>
    <section class="WorkSpaces">
      <h2 class="WS__title raleway-bold-p16 mb-4">VOTRE ESPACE DE TRAVAIL</h2>
  
      <div class="WS__grid">
        <!-- Left: Carousel -->
        <div class="WS__carousel" v-if="(images || []).length">
          <div class="WS__frame">
            <img :src="images[cur]" :alt="`Espace de travail ${cur+1}`" />
            <button class="WS__nav WS__nav--prev" type="button" @click="prev">‹</button>
            <button class="WS__nav WS__nav--next" type="button" @click="next">›</button>
          </div>
          <div class="WS__dots" v-if="images.length>1">
            <button
              v-for="(s,i) in images" :key="i"
              :class="['WS__dot', {active: i===cur}]"
              @click="cur=i"
              aria-label="changer la photo"
            />
          </div>
        </div>
  
        <!-- Right: Room cards -->
        <aside class="WS__aside" v-if="rooms && rooms.length">
          <div
            class="WS__card"
            v-for="(r, i) in roomsSorted"
            :key="r.id || i"
          >
            <div class="WS__roomTitle raleway-semi-p15">{{ r.title }}</div>
  
            <ul class="WS__ul raleway-reg-p15">
              <li v-for="(b, j) in (r.bullets || [])" :key="j">{{ b }}</li>
            </ul>
  
            <div class="WS__sep" v-if="i < roomsSorted.length - 1"></div>
          </div>
        </aside>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'WorkSpacesSection',
    props: {
      images: { type: Array, default: () => [] },
      rooms:  { type: Array, default: () => [] }
    },
    data(){ return { cur: 0 } },
    computed: {
      roomsSorted(){
        return [...this.rooms].sort((a,b)=> (a.position ?? 0) - (b.position ?? 0))
      }
    },
    methods:{
      next(){ this.cur = (this.cur + 1) % this.images.length },
      prev(){ this.cur = (this.cur - 1 + this.images.length) % this.images.length }
    }
  }
  </script>
  
  <style scoped>
  /* Section */
  .WorkSpaces{max-width:1200px;margin:0 auto;padding:16px 16px 24px}
  .WS__title{
    margin: 0 0 8px;
    text-align:center;
}
  
  /* Grid: desktop two columns, mobile stacked */
  .WS__grid{display:grid;gap:24px;grid-template-columns:2fr 1fr}
  @media (max-width: 980px){
    .WS__grid{grid-template-columns:1fr}
  }
  
  /* Carousel */
  .WS__frame{position:relative;border-radius:6px;overflow:hidden;background:#f3f3f3}
  .WS__frame img{width:100%;height:100%;object-fit:cover;display:block}
  .WS__nav{
    position:absolute;top:50%;transform:translateY(-50%);
    width:36px;height:36px;border-radius:50%;
    border:none;cursor:pointer;background:rgba(0,0,0,.35);color:#ffffff;
    display:flex;align-items:center;justify-content:center;font-size:20px
  }
  .WS__nav--prev{left:10px}
  .WS__nav--next{right:10px}
  .WS__nav:hover{background:rgba(0,0,0,.5)}
  .WS__dots{display:flex;gap:8px;justify-content:center;margin-top:8px}
  .WS__dot{width:8px;height:8px;border-radius:4px;background:#cfd6d2;border:none;cursor:pointer}
  .WS__dot.active{background:#2d5f49}
  
  /* Aside cards */
  .WS__aside{
    background:#ffffff;border:1px solid #e5e7e6;border-radius:8px;
    padding:18px 16px
  }
  .WS__card{padding:6px 4px}
  .WS__roomTitle{
    color:#2d5f49;letter-spacing:.3px;margin:0 0 10px 0
  }
  .WS__ul{list-style:none;margin:0 0 2px 0;padding:0;display:grid;gap:6px}
  .WS__ul li{color:#1a1a1a}
  .WS__sep{border-top:1px solid #e5e7e6;margin:14px 0 6px}
  </style>
  